<div class="container" *ngIf="shipmentDelivery">
    <div class="baractions">
        <div class="titol">{{'SHIPMENTDELIVERY.TITLE'| translate}}</div>
        <!--
            Tot va al mateix strip: editar/acabar edició, nova línia, i quan hi ha canvis
            pendents, desar i cancel·lar. Així l'usuari torna al mateix lloc on ha picat
            "Editar" per desar, en comptes d'haver de baixar al peu.
        -->
        <actions *ngIf="!hideactions" [actionstrip]="actions" (clickAction)="onClickAction($event)">
        </actions>
    </div>

    <!--
        Capçalera de la taula: sense això no es pot saber a què correspon cada valor
        de la línia. Es manté visible en mode edició també: només la línia oberta
        pel chevron es converteix en formulari, la resta segueixen mostrant-se
        compactes sota aquesta capçalera.
    -->
    <div class="line-header" *ngIf="lines && lines.length > 0">
        <div class="value lineNumber"></div>
        <div class="value quantity" *ngIf="columns.quantity">{{'DELIVERYLINE.QUANTITY.CAPTION' | translate}}</div>
        <div class="value units" *ngIf="columns.units">{{'DELIVERYLINE.UNITS.CAPTION' | translate}}</div>
        <div class="value reference" *ngIf="columns.reference">{{'DELIVERYLINE.REFERENCE.CAPTION' | translate}}</div>
        <div class="value description" *ngIf="columns.description">{{'DELIVERYLINE.DESCRIPTION.CAPTION' | translate}}
        </div>
        <div class="value unitPrice" *ngIf="columns.unitPrice">{{'DELIVERYLINE.UNITPRICE.CAPTION' | translate}}</div>
        <div class="value totalPrice" *ngIf="columns.totalPrice">{{'DELIVERYLINE.TOTALPRICE.CAPTION' | translate}}</div>
        <div class="value kg" *ngIf="columns.kg">{{'DELIVERYLINE.KG.CAPTION' | translate}}</div>
        <div class="value button-sub-line"></div>
    </div>

    <div class="line">
        <!--
            En edició, només la línia oberta (chevron) es mostra com a formulari;
            la resta es queden en format compacte encara que estiguem en mode
            edició. Obrir-ne una en tanca qualsevol altra (onExpandedLine és
            exclusiu), i afegir una línia nova ja l'obre automàticament.
        -->
        <shared-delivery-line *ngFor="let l of lines | sortBy:'line'" [line]="l" [columns]="columns"
            [allColumns]="allColumns" [readonly]="!canModify || !editMode || !isExpanded(l)" [expanded]="isExpanded(l)"
            [packageFixedFilterKeys]="packageFixedFilterKeys" [showDelete]="showDeleteButton(l)"
            (valueChanged)="onLineValueChanged()" (expandToggled)="onExpandedLine(l)"
            (deleteRequested)="onDeleteLine(l)" (deleteConfirmed)="onDeleteLine(l)"
            (deleteCancelled)="onDeleteSelectedEvent(null)" (addBatch)="onAddBatch(l)"
            (deleteBatch)="onDeleteBatch(l, $event)" (batchChanged)="onBatchValueChanged()">
        </shared-delivery-line>
    </div>

    <!--
        Peu de totals amb el mateix patró de plegar/desplegar que les línies
        (shared.delivery.line.component): una capçalera compacta sempre visible,
        en desplegar-la, el detall amb tots els totals fixables.
        Mentre un total no estigui fixat es mostra la suma en viu de la còpia de
        treball; si està fixat, el valor fixat guanya (és el que també farà servir
        el PDF). Desplegar el detall només serveix per fixar totals, així que el
        chevron (i la possibilitat d'obrir-lo) només existeix en mode edició; fora
        d'edició la capçalera ja mostra tots els totals, no cal cap detall extra.
    -->
    <div class="totals-footer">
        <div class="totals-summary" (click)="editMode && (totalsExpanded = !totalsExpanded)">
            <div class="element">
                <div class="prompt">{{'SHIPMENTDELIVERY.TOTALLINES.CAPTION' | translate}}:</div>
                <div class="total">{{totalLines() | quantity}}</div>
            </div>
            <div class="element" *ngFor="let field of primaryTotalFields">
                <div class="prompt">{{getTotalCaption(field) | translate}}:</div>
                <div class="total" [class.fixed]="getIsFixed(field)"
                    [title]="getIsFixed(field) ? ('SHIPMENTDELIVERY.TOTAL.FIXED.HELP' | translate) : ''">
                    {{(getIsFixed(field) ? getFixedValue(field) : getComputedTotal(field)) | quantity}}
                    <i *ngIf="getIsFixed(field)" class="fa fa-thumb-tack"></i>
                </div>
            </div>
            <!-- Desplegar el detall només serveix per fixar totals, cosa que només es pot fer en mode edició -->
            <div class="element button-sub-line" *ngIf="editMode">
                <i aria-hidden="true" class="cercle fa" [ngClass]="totalsExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            </div>
        </div>

        <!-- Detall: tots els totals en una graella horitzontal compacta -->
        <div class="totals-detail" *ngIf="totalsExpanded && editMode">
            <div class="totals-detail-item" *ngFor="let field of primaryTotalFields">
                <span class="prompt">{{getTotalCaption(field) | translate}}</span>
                <span class="value" [class.fixed]="getIsFixed(field)">
                    {{(getIsFixed(field) ? getFixedValue(field) : getComputedTotal(field)) | quantity}}
                </span>
                <ng-container *ngIf="editMode && canModify">
                    <checkbox-component [ngModel]="getIsFixed(field)" name="fix-{{field}}"
                        [label]="'SHIPMENTDELIVERY.TOTAL.FIX.CAPTION' | translate"
                        (valueChanged)="onToggleFixed(field, $event)"></checkbox-component>
                    <input-component *ngIf="getIsFixed(field)" [ngModel]="getFixedValue(field)"
                        name="fixvalue-{{field}}" type="number" class="fixvalue" autocomplete="off"
                        (valueChanged)="onFixedValueChanged(field, $event)"></input-component>
                </ng-container>
            </div>
        </div>
    </div>

</div>